import { createContext, useContext, useState, ReactNode } from "react";

type Language = "it" | "en";

interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: {
    (it: string, en: string): string;
    (it: string[], en: string[]): string[];
  };
}

const LanguageContext = createContext<LanguageContextType>({
  lang: "it",
  setLang: () => {},
  t: ((it: any, en: any) => it) as any,
});

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Language>("it");
  const t = ((it: any, en: any) => (lang === "it" ? it : en)) as LanguageContextType["t"];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
